import { useMemo, useState } from 'react'
import {
  deleteMotivoAtraso,
  getMotivoAtraso,
} from '../../../../services/api/https/registration/motivo-atraso.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_MOTIVOS: 'Adquirindo motivos',
  DELETE_MOTIVO: 'Excluindo motivo de atraso',
  DELETE_SUCCESS: 'Motivo deletado com sucesso',
}

export const MOTIVO_ATRASO_URL_TYPES = {
  VEICULO_T1: 'veiculo-t1',
  VEICULO_T2: 'veiculo-t2',
  ENTREGA: 'entrega',
}

const INITIAL_STATE = {
  modal: {
    show: false,
    data: null,
  },
  motivos: [],
  selectedMotivo: {},
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.GET_MOTIVOS,
  errorMessage: null,
}

export default function useMotivoAtraso() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const throwError = err => {
      setState(prevState => ({
        ...prevState,
        errorMessage: errorHandler(err),
        loadingMessage: LOAD_MESSAGE.NONE,
      }))
    }

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events
      getMotivosAtraso(selectedTp) {
        getMotivoAtraso(getUsuarioInfo().id, selectedTp)
          .then(motivos =>
            setState(prevState => ({
              ...prevState,
              motivos: motivos,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err => throwError(err))
      },

      deleteMotivoAtraso(motivoAtraso) {
        deleteMotivoAtraso(motivoAtraso.id)
          .then(() => {
            setState(prevState => {
              prevState.motivos = prevState.motivos.filter(m => m.id !== motivoAtraso.id)
              prevState.loadingMessage = LOAD_MESSAGE.DELETE_SUCCESS
              return { ...prevState }
            })
          })
          .catch(err => throwError(err))
      },

      onModalSave(motivoAtraso, selectedTp) {
        setState(prevState => {
          const tpsMotivo = motivoAtraso.tps.map(tp => tp.id)
          const index = prevState.motivos.findIndex(m => m.id === motivoAtraso.id)
          if (!tpsMotivo.includes(selectedTp) && selectedTp) {
            prevState.motivos = prevState.motivos.filter(m => m.id !== motivoAtraso.id)
          } else {
            if (index !== -1) prevState.motivos[index] = motivoAtraso
            else prevState.motivos.push(motivoAtraso)
          }
          prevState.modal = { show: false, data: null }
          return { ...prevState }
        })
      },

      onMenuItemClicked(item, selectedMotivo) {
        switch (item) {
          case 'Editar':
            setState(prevState => ({ ...prevState, modal: { show: true, data: selectedMotivo } }))
            break
          case 'Apagar':
            setState(prevState => ({
              ...prevState,
              selectedMotivo: selectedMotivo,
              loadingMessage: LOAD_MESSAGE.DELETE_MOTIVO,
            }))
            break
          default:
            break
        }
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
      },

      onBtnClickNovo() {
        setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
